webpackJsonp([79704588751377],{

/***/ 1512:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PriceChangeInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"description","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"filters","type":{"kind":"LIST","name":null,"ofType":{"kind":"INPUT_OBJECT","name":"PriceChangeFilterInput","ofType":null}}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"priceChangeType","type":{"kind":"ENUM","name":"PriceChangeType","ofType":null}},{"defaultValue":null,"description":null,"name":"priceChangeValue","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"pricingType","type":{"kind":"ENUM","name":"PricingType","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-price-change-input-dd7fba88209c5e31b332.js